/* istanbul ignore file */
/**
 * DataTable component theme configuration.
 */

export const dataTableComponentConfig = {
  datatable: {
    root: {
      transitionDuration: '{transition.duration}',
    },
    header: {
      background: '{content.background}',
      borderColor: '{greymatter.100}',
      color: '{content.color}',
      borderWidth: '1px 0 1px 0',
      padding: '0.75rem 1rem',
    },
    headerCell: {
      background: '{content.background}',
      hoverBackground: '{greymatter.50}',
      selectedBackground: '{highlight.background}',
      borderColor: '{greymatter.100}',
      color: '{content.color}',
      hoverColor: '{content.hover.color}',
      selectedColor: '{highlight.color}',
      gap: '0.5rem',
      padding: '0.75rem 1rem',
      focusRing: {
        width: '{focus.ring.width}',
        style: 'none',
        color: '{focus.ring.color}',
        offset: '0',
        shadow: 'inset {focus.ring.shadow}',
      },
    },
    columnTitle: {
      fontWeight: '700',
    },
    row: {
      background: '{content.background}',
      hoverBackground: '{content.hover.background}',
      selectedBackground: '{highlight.background}',
      color: '{content.color}',
      hoverColor: '{content.hover.color}',
      selectedColor: '{highlight.color}',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '-1px',
        shadow: '{focus.ring.shadow}',
      },
    },
    bodyCell: {
      borderColor: '{greymatter.100}',
      padding: '0.75rem 1rem',
    },
    footerCell: {
      background: '{content.background}',
      borderColor: '{content.border.color}',
      color: '{content.color}',
      padding: '0.75rem 1rem',
    },
    columnFooter: {
      fontWeight: '700',
    },
    footer: {
      background: '{content.background}',
      borderColor: '{datatable.border.color}',
      color: '{content.color}',
      borderWidth: '0 0 1px 0',
      padding: '0.75rem 1rem',
    },
    dropPoint: {
      color: '{primary.color}',
    },
    resizeIndicator: {
      width: '1px',
      color: '{primary.color}',
    },
    sortIcon: {
      color: '{text.muted.color}',
      hoverColor: '{text.hover.muted.color}',
      size: '0.875rem',
    },
    loadingIcon: {
      size: '2rem',
    },
    colorScheme: {
      light: {
        root: {
          borderColor: '{surface.300}',
        },
        row: {
          stripedBackground: '{surface.50}',
        },
        bodyCell: {
          selectedBorderColor: '{primary.100}',
        },
      },
    },
  },
};
